import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWind: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="wind, windy"><path d="M2.75 12H19.25C20.3546 12 21.25 11.1046 21.25 10C21.25 8.89544 20.3546 8.00001 19.25 8.00001C18.6341 8.00001 18.0832 8.27844 17.7163 8.7163M2.75 7.75001L11.25 7.75C12.3546 7.75 13.25 6.85457 13.25 5.75C13.25 4.64543 12.3546 3.75 11.25 3.75C10.6341 3.75 10.0869 4.02843 9.72 4.46629M2.75 16.25H15.25C16.3546 16.25 17.25 17.1454 17.25 18.25C17.25 19.3546 16.3546 20.25 15.25 20.25C14.57 20.25 13.9693 19.9107 13.6079 19.3921" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconWind;
